// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import snackbar from './snackbar';

const reducers = combineReducers({
  menu,
  snackbar
});

export default reducers;
